import {saveAs} from "file-saver";
import React from "react";
import {ButtonGroup} from "react-bootstrap";
import {TbPng, TbSvg} from "react-icons/tb";
import Sigma from "sigma";

import "../css/screenshot.css";
import {useTheCellMapContext} from "../contexts/TheCellMapContext";
import {useFileRegions} from "../hooks/useJsonLoader";
import useOverlaySvg from "../screenshot/useOverlaySvg";
import useScreenshotPng from "../screenshot/useScreenshotPng";
import useNetworkSvg from "../screenshot/useNetworkSvg";
import {OverlayResults} from "../types/overlay";
import {Annotation, Dataset} from "../types/Types";

type ScreenshotProps = {
  fileName: string;
  sigma?: Sigma | null;
  legendAnnotations?: Annotation[] | null;
  showLegend?: boolean;
  overlayResults?: OverlayResults;
  dataset?: Dataset;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Screenshot = ({
                      fileName,
                      sigma = null,
                      legendAnnotations,
                      showLegend = false,
                      overlayResults,
                      dataset,
                      ...buttonProps
                    }: ScreenshotProps) => {
  const {selectedGenes} = useTheCellMapContext();
  const regions = useFileRegions();

  const screenshotPng = useScreenshotPng(sigma);
  const screenshotSvg = useNetworkSvg(sigma, selectedGenes.length > 0 ? regions : null, legendAnnotations, showLegend);
  const overlaySvg = useOverlaySvg(overlayResults, dataset, regions);

  const isOverlay = overlayResults !== undefined || dataset !== undefined;

  const handlePNGScreenshot = () => {
    screenshotPng().then((blob) => {
      saveAs(blob, `${fileName}.png`);
    }).catch((err) => {
      console.error(err);
    });
  };

  const handleSVGScreenshot = () => {
    const fn = isOverlay ? overlaySvg : screenshotSvg;
    fn().then((blob) => {
      saveAs(blob, `${fileName}.svg`);
    }).catch((err) => {
      console.error(err);
    });
  };

  return (
    <div className="screenshot-btn-group">
      <ButtonGroup vertical>
        <button
          onClick={handlePNGScreenshot}
          className="btn btn-outline-light screenshot-slide-btn"
          aria-label="Download as PNG"
          title="Download as PNG"
          {...buttonProps}
        >
          <TbPng className="ui-icon"/>
        </button>
        <button
          onClick={handleSVGScreenshot}
          className="btn btn-outline-light screenshot-main-btn"
          aria-label="Download as SVG"
          title="Download as SVG"
          {...buttonProps}
        >
          <TbSvg className="ui-icon"/>
        </button>
      </ButtonGroup>
    </div>
  );
};

export default Screenshot;